window.prazdnyKosikNadpis = [
  { language: "cs", text: "Váš košík je prázdný." },
  { language: "en", text: "Your cart is empty." },
  { language: "de", text: "Ihr Warenkorb ist leer." },
];

window.prazdnyKosikPerex = [
  {
    language: "cs",
    text: "Pokud nevíte, jaký produkt vybrat, zkuste se podívat do naší poradny nebo zavolejte přímo nám, rádi vám pomůžeme.",
  },
  {
    language: "en",
    text: "If you don't know which product to choose, try looking at our advice section or call us directly, we will be happy to help you.",
  },
  {
    language: "de",
    text: "Wenn Sie nicht wissen, welches Produkt Sie wählen sollen, schauen Sie in unseren Beratungsbereich oder rufen Sie uns direkt an, wir helfen Ihnen gerne weiter.",
  },
];

window.primaryButtonText = [
  { language: "cs", text: "Zpět do obchodu", url: "/" },
  { language: "en", text: "Back to shop", url: "/" },
  { language: "de", text: "Zurück zum Shop", url: "/" },
];

window.secondaryButtonText = [
  { language: "cs", text: "Kontakty", url: "/kontakty" },
  { language: "en", text: "Contacts", url: "/kontakty" },
  { language: "de", text: "Kontakte", url: "/kontakty" },
];

window.emailPerexText = [
  { language: "cs", text: "Odpovídáme do 24 hodin" },
  { language: "en", text: "We respond within 24 hours" },
  { language: "de", text: "Wir antworten innerhalb von 24 Stunden" },
];

window.recenzeBtnText = [
  { language: "cs", text: "Zobrazit vše" },
  { language: "en", text: "Show more" },
  { language: "de", text: "Alles anzeigen" },
];

window.hodnoceniNadpis = [
  { language: "cs", text: "Zpětná vazba" },
  { language: "en", text: "Feedback" },
  { language: "de", text: "Feedback" },
];

window.dopravaVHlavicce = [
  { language: "cs", text: "Doprava zdarma od 999 Kč" },
  { language: "en", text: "Free shipping from 999 CZK" },
  { language: "de", text: "Kostenloser Versand ab 999 CZK" },
];

window.kosik = [
  { language: "cs", text: "Košík" },
  { language: "en", text: "Cart" },
  { language: "de", text: "Warenkorb" },
];

window.availabilityTitle = [
  { language: "cs", text: "Dostupnost" },
  { language: "en", text: "Availability" },
  { language: "de", text: "Verfügbarkeit" },
];

window.extraGiftTitles = [
  { language: "cs", text: "Slevový kód" },
  { language: "en", text: "Discount code" },
  { language: "de", text: "Rabattcode" },
];

window.itemsCartTitle = [
  { language: "cs", text: "Nákupní košík" },
  { language: "en", text: "Shopping cart" },
  { language: "de", text: "Einkaufswagen" },
];

window.productDetailAddBtn = [
  { language: "cs", text: "DARUJ" },
  { language: "en", text: "GIVE" },
  { language: "de", text: "GEBEN" },
];

window.productDetailFavourite = [
  { language: "cs", text: "Přidat do oblíbených", remove: "Odebrat" },
  { language: "en", text: "Add to favorites", remove: "Remove" },
  { language: "de", text: "Zu Favoriten hinzufügen", remove: "Entfernen" },
];

window.filterBtnText = [
  { language: "cs", text: "Detailní filtrace" },
  { language: "en", text: "Detailed filtering" },
  { language: "de", text: "Detaillierte Filterung" },
];

window.filterBtnTextClose = [
  { language: "cs", text: "Zavřít filtraci" },
  { language: "en", text: "Close filtering" },
  { language: "de", text: "Filterung schließen" },
];

window.newsBtnText = [
  { language: "cs", text: "Zobrazit článek" },
  { language: "en", text: "Show article" },
  { language: "de", text: "Artikel anzeigen" },
];

window.alternativeNadpis = [
  { language: "cs", text: "Podobné produkty" },
  { language: "en", text: "Similar products" },
  { language: "de", text: "Ähnliche Produkte" },
];



window.kosik = [
  {
    language: "cs",
    text: "Celková velikost souborů překračuje maximální velikost 25 MB.",
  },
  {
    language: "en",
    text: "The total file size exceeds the maximum size of 25 MB.",
  },
  {
    language: "de",
    text: "Die Gesamtgröße der Dateien überschreitet die maximale Größe von 25 MB.",
  },
];

window.newsLetterTitle = [
  { language: "cs", text: "Aktuální novinky <br> a akce na váš e-mail" },
  { language: "en", text: "Current news <br> and promotions to your email" },
  {
    language: "de",
    text: "Aktuelle Nachrichten <br> und Aktionen an Ihre E-Mail",
  },
];

window.newsLetterPerex = [
  {
    language: "cs",
    text: "Získejte exkluzivní novinky, speciální nabídky a přehled o nejnovějších modelech hodinek přímo do své schránky. Přihlaste se k odběru našeho newsletteru.",
  },
  {
    language: "en",
    text: "Get exclusive news, special offers and an overview of the latest watch models directly to your inbox. Subscribe to our newsletter.",
  },
  {
    language: "de",
    text: "Erhalten Sie exklusive Nachrichten, Sonderangebote und einen Überblick über die neuesten Uhrenmodelle direkt in Ihren Posteingang. Abonnieren Sie unseren Newsletter.",
  },
];

window.newsLetterBtn = [
  { language: "cs", text: "Odebírat newsletter" },
  { language: "en", text: "Subscribe to newsletter" },
  { language: "de", text: "Newsletter abonnieren" },
];

window.specificationTabText = [
  { language: "cs", text: "Specifikace" },
  { language: "en", text: "Specifications" },
  { language: "de", text: "Spezifikationen" },
];

window.subcategoriesBtnCategory = [
  { language: "cs", text: "Značky" },
  { language: "en", text: "Brands" },
  { language: "de", text: "Marken" },
];

window.filteringMobileBtnText = [
  { language: "cs", text: "Filtrovat" },
  { language: "en", text: "Filter" },
  { language: "de", text: "Filtern" },
];

window.flagsIcons = [
  {
    language: "cs",
    imgUrl: "/user/documents/upload/newDesign/flags/flag-cz.svg",
  },
  {
    language: "en",
    imgUrl: "/user/documents/upload/newDesign/flags/flag-us.svg",
  },
  {
    language: "de",
    imgUrl: "/user/documents/upload/newDesign/flags/flag-uk.svg",
  },
];

// window.blogOnHpTitle = [
//   { language: "cs", text: "Společně jsme zachránili" },
//   { language: "en", text: "Together we saved" },
//   { language: "de", text: "Gemeinsam haben wir gerettet" },
// ];

window.blogOnHpLink = [
  { language: "cs", text: "Zobrazit blog", url: "/smutny-pribeh-nasej-river" },
  { language: "en", text: "View blog", url: "/smutny-pribeh-nasej-river" },
  { language: "de", text: "Blog anzeigen", url: "/smutny-pribeh-nasej-river" },
];

// window.cartDeliveryTitle = [
//   { language: "cs", text: "Vyberte útulek, do kterého chcete doručit zboží" },
//   {
//     language: "en",
//     text: "Select the shelter to which you want to deliver the goods",
//   },
//   {
//     language: "de",
//     text: "Wählen Sie das Tierheim aus, in das Sie die Waren liefern möchten",
//   },
// ];

window.cartContinueBtn = [
  { language: "cs", text: "Pokračovat v objednávce" },
  { language: "en", text: "Continue" },
  { language: "de", text: "Fortsetzen" },
];

window.searchText = [
  { language: "cs", text: "Hledat" },
  { language: "en", text: "Search" },
  { language: "de", text: "Search" },
];
